import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'

const TableBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`table-block ${block.space_top ? block.space_top : ''} ${
          block.space_bottom ? block.space_bottom : ''
        }`}
      >
        <div className="table-block-content">
          <div className="row">
            <div className="col-12">
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
              />
              <table className="table table-bordered table-striped w-auto">
                <thead>
                  <tr>
                    {block.table.thead?.length > 0 &&
                      block.table.thead.map((head, index) => (
                        <th
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: head.replace('--', '<br/>'),
                          }}
                        ></th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {block.table.tbody?.length > 0 &&
                    block.table.tbody.map((row, index) => (
                      <tr key={index}>
                        {row.map((col, index) => (
                          <td key={index}>{col}</td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TableBlock
